import React from 'react';
import { Button } from '@frontend/shadcn/components/ui/button';
import { cn } from '@frontend/shadcn/lib/utils';
import { XmarkIcon, PlayIcon } from '@revfluence/fresh-icons/solid/esm';

interface VideoPreviewProps {
  videoUrl: string;
  onRemove: () => void;
  className?: string;
  allowChange?: boolean;
  onMediaSelect?: (base64Video: string) => void;
}

export const VideoPreview: React.FC<VideoPreviewProps> = ({
  videoUrl,
  onRemove,
  className = '',
  allowChange = false,
  onMediaSelect,
}) => {
  const handleMediaSelect = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,video/*';
    input.onchange = (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          onMediaSelect?.(reader.result as string);
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();
  };

  return (
    <div className={cn('relative w-[88px] h-[88px]', className)}>
      <div className="w-full h-full rounded-2xl overflow-hidden bg-gray-100 flex items-center justify-center">
        <video
          src={videoUrl}
          className="w-full h-full object-cover"
          onClick={allowChange ? handleMediaSelect : undefined}
          style={{ cursor: allowChange ? 'pointer' : 'default' }}
        >
          <track kind="captions" src="" label="English" />
        </video>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-8 h-8 bg-black bg-opacity-50 rounded-full flex items-center justify-center">
            <PlayIcon className="w-4 h-4 text-white" />
          </div>
        </div>
      </div>
      <Button
        variant="secondary"
        size="smallIcon"
        className="absolute top-2 right-2"
        onClick={onRemove}
        aria-label="Remove video"
      >
        <XmarkIcon />
      </Button>
    </div>
  );
};
